import { render } from "./OPendingMember.vue?vue&type=template&id=9f3465f8&scoped=true"
import script from "./OPendingMember.vue?vue&type=script&lang=js"
export * from "./OPendingMember.vue?vue&type=script&lang=js"

import "./OPendingMember.vue?vue&type=style&index=0&id=9f3465f8&scoped=true&lang=css"
import "./OPendingMember.vue?vue&type=style&index=1&id=9f3465f8&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f3465f8"]])

export default __exports__